import { render, staticRenderFns } from "./StickyPlayer.vue?vue&type=template&id=60cb629f"
import script from "./StickyPlayer.vue?vue&type=script&lang=js"
export * from "./StickyPlayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../Viberary/repos/viberary-frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports